import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { UtilsService } from 'src/app/services/utils.service';
import { MaintenanceService } from 'src/app/services/maintenance.service';
import { forkJoin } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-maintenance-view',
    templateUrl: './maintenance-view.component.html',
    styleUrls: ['./maintenance-view.component.css']
})
export class MaintenanceViewComponent {
    dataUser: any = {}
    constructor(
        private location: Location,
        private utils: UtilsService,
        private apiMaintenance: MaintenanceService,
        private spinner: NgxSpinnerService,
        private route: ActivatedRoute
    ) { }

    urlPage = environment.url_page
    dataMaintenance: any = {}

    // AG Grid – refacciones (read-only)
    spareGridApi: any = null
    spareColDefs: any[] = []
    spareDefaultColDef: any = { sortable: false, filter: false, resizable: false, flex: 1 }

    ngOnInit(): void {
        this.spinner.show()
        this.dataUser = this.utils.getDataUser()
        this.buildSpareColDefs()

        forkJoin([this.apiMaintenance.showMaintenance(this.route?.snapshot?.params['id'])]).subscribe(([resp1]) => {
            this.dataMaintenance = (resp1 as any).data || {}
            if (this.spareGridApi) {
                this.spareGridApi.setRowData(this.dataMaintenance?.repair_requests ?? [])
            }
            this.spinner.hide()
        })
    }

    onSpareGridReady(params: any) {
        this.spareGridApi = params.api
        if (this.dataMaintenance?.repair_requests?.length) {
            this.spareGridApi.setRowData(this.dataMaintenance.repair_requests)
        }
    }

    private buildSpareColDefs() {
        this.spareColDefs = [
            {
                headerName: 'Refacción',
                field: 'repair',
                flex: 2,
                headerClass: 'spare-left',
                valueGetter: (p: any) => p.data?.repair?.name ?? '—',
                cellRenderer: (p: any) => `<strong>${p.value}</strong>`
            },
            {
                headerName: 'Categoría',
                field: 'repair',
                flex: 1,
                valueGetter: (p: any) => p.data?.repair?.category?.trim() || 'Sin categoría'
            },
            {
                headerName: 'Costo unitario',
                flex: 1,
                valueGetter: (p: any) => p.data?.unit_cost ?? p.data?.cost ?? 0,
                valueFormatter: (p: any) => `$${(+p.value).toFixed(2)} MXN`
            },
            {
                headerName: 'Cantidad',
                flex: 1,
                valueGetter: (p: any) => p.data?.quantity ?? 1,
                cellStyle: { textAlign: 'center' }
            },
            {
                headerName: 'Subtotal',
                flex: 1,
                valueGetter: (p: any) => (p.data?.unit_cost ?? p.data?.cost ?? 0) * (p.data?.quantity ?? 1),
                valueFormatter: (p: any) => `$${(+p.value).toFixed(2)} MXN`
            }
        ]
    }

    get totalRepairs(): number {
        return (this.dataMaintenance?.repair_requests ?? []).reduce(
            (sum: number, r: any) => sum + ((r.unit_cost ?? r.cost ?? 0) * (r.quantity ?? 1)), 0
        )
    }

    get isInternal(): boolean {
        const name = (this.dataMaintenance?.maintenance_type?.name ?? '').trim().toUpperCase()
        return name === 'INTERNO'
    }

    get isCriticoOrReparacion(): boolean {
        const name = (this.dataMaintenance?.priority?.name ?? '').trim().toUpperCase()
        return name.includes('CRITICO') || name.includes('CRÍTICO') || name.includes('REPARACI')
    }

    get isPreventivo(): boolean {
        const name = (this.dataMaintenance?.priority?.name ?? '').trim().toUpperCase()
        return name.includes('PREVENTIVO')
    }

    indexToLetter(i: number): string {
        const base = 'A'.charCodeAt(0)
        let n = i
        let result = ''
        do {
            result = String.fromCharCode(base + (n % 26)) + result
            n = Math.floor(n / 26) - 1
        } while (n >= 0)
        return result
    }
}
